import { Injectable } from '@angular/core';
import {
  AuctionSummaryService,
  PurchasedItemDto,
  PurchaseReportEmailRequestDto,
  PurchaseReportRequestDto,
  ReportType
} from 'remarketing-angular-library';
import { take } from 'rxjs/operators';
import {Store} from "@ngxs/store";
import { get } from 'lodash';

@Injectable({
  providedIn: 'root'
})
export class ReportUtilityService {

  public fileURL: string;

  constructor(
      private readonly auctionSummaryService: AuctionSummaryService,
      private readonly store: Store
  ) {}

  revokeUrl() {
    URL.revokeObjectURL(this.fileURL);
  }

  openBlob(blob: Blob, filename?: string) {
    // revoke URL for previous report if present
    if (this.fileURL) {
      URL.revokeObjectURL(this.fileURL);
    }
    const nav = (window.navigator as any);
    if (nav && nav.msSaveOrOpenBlob) {
      nav.msSaveOrOpenBlob(blob, filename);
    } else {
      this.fileURL = URL.createObjectURL(blob);
      window.open(this.fileURL, '_blank');
    }
  }

  printPurchasedItems(purchasedItemDtos: PurchasedItemDto[], reportType: ReportType = null, reportList: ReportType[] = null) {
    this.auctionSummaryService.viewPurchasedItemReports(
      this.createPurchaseReportRequest(purchasedItemDtos, reportType, reportList))
      .pipe(take(1))
      .subscribe(response => {
        const filename = response.headers.get('content-disposition');
        const blob = new Blob([response.body], { type: 'application/pdf' });
        this.openBlob(blob, filename);
      });
  }

  static getFilename(contentDisposition: string): string | undefined {
    const filenameInfo = contentDisposition.split(';')[1];
    return filenameInfo.split('=')[1];
  }

  createPurchaseReportRequest(purchasedItemDtos: PurchasedItemDto[], reportType: ReportType, reportList: ReportType[] = null): PurchaseReportRequestDto {
    const auctionItemUuids = [];
    for (const purchasedItemDto of purchasedItemDtos) {
      auctionItemUuids.push(purchasedItemDto.auctionItemUuid);
    }
    return {
      reportType: reportType,
      reportTypes: reportList,
      auctionItemUuids: auctionItemUuids,
      locale: this.preferredLocale
    } as PurchaseReportRequestDto;
  }

  createPurchaseReportEmailRequest(purchasedItemDtos: PurchasedItemDto[], reportType: ReportType, emailTo: string[], reportList: ReportType[] = null):
    PurchaseReportEmailRequestDto {
    const auctionItemUuids = [];
    for (const purchasedItemDto of purchasedItemDtos) {
      auctionItemUuids.push(purchasedItemDto.auctionItemUuid);
    }
    return {
      reportType: reportType,
      reportTypes: reportList,
      auctionItemUuids: auctionItemUuids,
      email: emailTo,
      locale: this.preferredLocale
    } as PurchaseReportEmailRequestDto;
  }

  get preferredLocale() {
    return this.store.selectSnapshot(state =>
        get(state, 'user.userProfile.userPreferences.preferredLocale', null)
    );
  }
}
